// Shared pure helpers for the music player components.

/**
 * Resolve a cover image URL.
 * - blob: URLs are used directly (and any accidental prefix before `blob:` is stripped).
 * - non-blob paths are prefixed with the API static base, which is empty in production
 *   (VITE_API_URL=/api → staticBaseUrl=''), so the path is returned as-is there.
 */
export function getProperImageUrl(coverUrl: string | undefined): string {
  if (!coverUrl) return '';

  if (coverUrl.startsWith('blob:')) return coverUrl;
  if (coverUrl.includes('blob:')) return coverUrl.substring(coverUrl.indexOf('blob:'));

  const apiBaseUrl = import.meta.env.VITE_API_URL || '/api';
  const staticBaseUrl = apiBaseUrl.replace('/api', '');
  return `${staticBaseUrl}${coverUrl}`;
}
